import React from "react";
import { HandleInvoiceStateProvider } from "./Components/HandleInvoiceStateProvider";
import NewDebitNotePrime from "./NewDebitNotePrime";
import { AccountDetailsProvider } from "./Components/AccountDetailsProvider";

function CreateDebitNote({ isVoucher ,accountDetails}) {
  return (
    <AccountDetailsProvider accountDetails={accountDetails} >
    <HandleInvoiceStateProvider>
      <NewDebitNotePrime isVoucher={isVoucher}/>
    </HandleInvoiceStateProvider>
    </AccountDetailsProvider>
  );
}

export default CreateDebitNote;
